import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICategoryResource } from "../types";

export type ICategoryDeleteMutationParameters = {
    category: RelationalValue<ICategoryResource>;
};

export type ICategoryDeleteMutationResult = void;

export const categoryDeleteMutation: IApiMutationFunction<ICategoryDeleteMutationParameters> = ({ category }) => {
    return {
        method: "DELETE",
        url: `/categories/${mapRelationalValue(category)}`,
    };
};

export const useCategoryDeleteMutation = createApiMutationHook<
    ICategoryDeleteMutationParameters,
    ICategoryDeleteMutationResult
>(categoryDeleteMutation);
